import { TypedDefinition } from '@rehaje/core'

import type { InterfaceGenerateOptions, TypedSchema } from '@rehaje/core'

export class MappingFunctionDefinition extends TypedDefinition {
  override properties: TypedSchema[] = [
    {
      name: 'type',
      type: 'Schema.String'
    },
    {
      name: 'id',
      type: 'Schema.String'
    },
    {
      name: 'return',
      type: 'Schema.Identifier',
      value: 'T'
    }
  ]

  override relationTo = 'Schema.MappingFunction'

  override getTypeScript(options?: InterfaceGenerateOptions): string {
    return super.getTypeScript({
      ...options,
      generics: ['T']
    })
  }
}

declare global {
  export interface RehajeTypedDefinitions {
    MappingFunction: MappingFunctionDefinition
  }
}
